module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_null@3x.d9f90a59.png";